import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ZuiShellBase } from './zui-shell-base';
import { style } from './zui-shell-footer-css.js';

/**
 * The footer is the small section at the bottom of each page that contains things like the privacy and cookie policies, and other legal and trademark information.
 *
 * @element zui-shell-footer
 *
 * @slot - Default, unnamed slot; for inserting all privacy and cookie policies, and other legal and trademark information into `<zui-shell-footer>`
 *
 * @cssprop [--zui-shell-footer-height=(variable)] - Height of `<zui-shell-footer>`
 */
export class ZuiShellFooter extends ZuiShellBase {
  static get styles() {
    return [super.styles, style];
  }

  constructor() {
    super();

    this._observeNavCollapseChange = true;
    this._observeHasShellNav = true;
  }

  render() {
    return html`
      <footer class="footer ${classMap({ 'nav-collapsed': this._isNavCollapsed, 'no-nav': !this._hasShellNav })}">
        <slot></slot>
      </footer>
    `;
  }
}

window.customElements.define('zui-shell-footer', ZuiShellFooter);

declare global {
  interface HTMLElementTagNameMap {
    'zui-shell-footer': ZuiShellFooter;
  }
}
